module.exports = "<md-dialog-content class=\"dialog-see-all-properties-wrapper-tooltips\">\n  <div class=\"dialog-see-all-properties-wrapper\">\n    <div *ngIf=\"!isCustomText\" class=\"content\">\n      {{'search-box-over-budget-hover-info-label' | translate }}\n    </div>\n    <div *ngIf=\"isCustomText\" class=\"content\">\n       {{ text }}\n    </div>\n    <div class=\"footer-close-btn\" (click)=\"close()\">{{'dialog-close' | translate}}</div>\n  </div>\n</md-dialog-content>\n"


//////////////////
// WEBPACK FOOTER
// ./src/app/components/modal/dialog-see-all-properties/dialog-see-all-properties.component.html
// module id = 1068
// module chunks = 22